import React from "react";
import { Offcanvas, Badge } from "react-bootstrap";
import { useTranslation } from "react-multi-lang";

const ViewBankAccountModal = ({ account, show, onHide }) => {
  const t = useTranslation("bank_index");

  if (!account) return null;

  return (
    <Offcanvas show={show} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {t("view_bank_account")}
          {account.is_default ? (
            <Badge bg="primary" className="ms-2">
              {t("default")}
            </Badge>
          ) : null}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="view-modal-wrap">
          <div className="view-modal-card-wrap">
            <div className="view-modal-card">
              <div className="text-muted small">{t("account_holder_name")}</div>
              <div className="fw-semibold">{account.account_holder_name}</div>
            </div>

            <div className="view-modal-card">
              <div className="text-muted small">{t("ifsc_code")}</div>
              <div className="fw-semibold">{account.ifsc_code}</div>
            </div>

            <div className="view-modal-card">
              <div className="text-muted small">{t("account_number")}</div>
              <div className="fw-semibold">{account.account_number}</div>
            </div>

            <div className="view-modal-card">
              <div className="text-muted small">{t("bank_name")}</div>
              <div className="fw-semibold">{account.bank_name}</div>
            </div>

            <div className="view-modal-card">
              <div className="text-muted small">{t("account_type")}</div>
              <div className="fw-semibold text-capitalize">{account.account_type}</div>
            </div>

            <div className="view-modal-card">
              <div className="text-muted small">{t("created_at")}</div>
              <div className="fw-semibold">{account.created_at || "-"}</div>
            </div>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ViewBankAccountModal;
